// extracted by mini-css-extract-plugin
module.exports = {"pulseButton":"styles_pulseButton__20nU8","pulse":"styles_pulse__205-x","noPulseButton":"styles_noPulseButton__3OmoX","micIcon":"styles_micIcon__1mh3U"};